import { render, staticRenderFns } from "./related-tags.vue?vue&type=template&id=e50a88fe&"
import script from "./related-tags.vue?vue&type=script&lang=ts&"
export * from "./related-tags.vue?vue&type=script&lang=ts&"
import style0 from "./related-tags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports